import api from './utilBackoffice';

const controller = 'MovimentoContabil';
const url = process.env.VUE_APP_ROOT_API + controller;
export default Object.assign({}, api.GetCrud(controller, null), {
  Listar: dto => {
    return api.Axios.GetParams(url, dto);
  },
  InvokeLambdaRelatorio: dto => {
    return api.Axios.Post(url + '/InvokeLambdaRelatorio', dto);
  },
  DownloadXlsx: (dto, filename) => {
    return api.Axios.DownloadExcelFile(url + '/DownloadXlsx', dto, filename);
  },
  DownloadTxt: (dto, filename) => {
    return api.Axios.DownloadTxtFile(url + '/DownloadTxt', dto, filename);
  },
  GetMovimentosSemGeracao: dto => {
    return api.Axios.GetParams(url + '/GetMovimentoContabilSemGeracao', dto);
  }
});
